type BrowsableStyle = {
  id: number;
  category: string;
  created_at?: string;
  is_favorited?: boolean;
};

const newestFirst = (a: BrowsableStyle, b: BrowsableStyle): number =>
  (b.created_at || '').localeCompare(a.created_at || '') || b.id - a.id;

/**
 * スタイル一覧の並び: お気に入り → 各カテゴリの新しい順を1件ずつ交互 → 新しい順。
 * 新しい順だけだと、まとめて登録した1カテゴリが先頭を埋める
 * （2026-09-29 にペット88件を登録し、「すべて」の先頭100件中88件が犬猫になった）。
 * master のサーバー（StylesController::getStyles）も同じ順でページを切る。
 */
export const buildStyleBrowsingComparator = <T extends BrowsableStyle>(styles: T[]) => {
  const byCategory = new Map<string, T[]>();
  styles.forEach((style) => {
    byCategory.set(style.category, [...(byCategory.get(style.category) ?? []), style]);
  });
  const rank = new Map<number, number>();
  byCategory.forEach((list) => {
    [...list].sort(newestFirst).forEach((style, index) => rank.set(style.id, index));
  });

  return (a: T, b: T): number =>
    Number(Boolean(b.is_favorited)) - Number(Boolean(a.is_favorited))
    || (rank.get(a.id) ?? 0) - (rank.get(b.id) ?? 0)
    || newestFirst(a, b);
};
